import { Tooltip as MtTooltip } from "@mantine/core";
import type { FC, ReactNode } from "react";

import { Color } from "src/theme";

const TOOLTIP_BODY_STYLES = {
    backgroundColor: Color.white,
    border: `1px solid ${Color.gray25}`,
    color: Color.black,
    boxShadow: "rgba(148, 163, 187, 0.32) 0px 4px 25px;",
} as const;

type TooltipProps = {
    content: ReactNode;
    withArrow?: boolean;
};

export const Tooltip: FC<TooltipProps> = ({ children, content, withArrow }) => (
    <MtTooltip
        styles={{
            body: TOOLTIP_BODY_STYLES,
        }}
        withArrow={withArrow}
        label={content}
    >
        {children}
    </MtTooltip>
);
